import styled from 'styled-components'
import DividerBase from 'components/divider'

export const Divider = styled(DividerBase)`
    height: 2px;
    margin: 32px 0;
`